import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, map, takeUntil } from 'rxjs';
import { EventCardsService } from 'src/app/services/event-cards.service';
import { EventCard } from 'src/interfaces/event-card.model';

/**
 * События на десктопе: постеры 3:4 по 7 в ряд, без подписей; больше семи — лента
 * со стрелками. Нажатие — постер во весь экран. Отбор и порядок —
 * как в мобильном слайдере (активные, без прошедших, по index)
 */
@Component({
    selector: 'app-desktop-events',
    templateUrl: './desktop-events.component.html',
    styleUrls: ['./desktop-events.component.css'],
    standalone: false
})
export class DesktopEventsComponent implements OnInit, OnDestroy {
  @ViewChild('strip') strip?: ElementRef<HTMLElement>;

  events: EventCard[] = [];
  opened: EventCard | null = null;
  canBack = false;
  canForward = false;

  private destroy$ = new Subject<void>();

  constructor(private eventCardsService: EventCardsService) {}

  ngOnInit(): void {
    this.eventCardsService.eventCards$.pipe(
      takeUntil(this.destroy$),
      map((cards) => {
        const now = new Date();
        return cards
          .filter((card) => card.active && (card.deadline === null || card.deadline >= now))
          .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      }),
    ).subscribe((cards) => {
      this.events = cards;
      setTimeout(() => this.updateArrows());
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  updateArrows(): void {
    const el = this.strip?.nativeElement;
    if (!el) return;
    this.canBack = el.scrollLeft > 4;
    this.canForward = el.scrollLeft + el.clientWidth < el.scrollWidth - 4;
  }

  scroll(direction: 1 | -1): void {
    const el = this.strip?.nativeElement;
    el?.scrollBy({ left: direction * el.clientWidth, behavior: 'smooth' });
  }

  @HostListener('document:keydown.escape')
  closePoster(): void {
    this.opened = null;
  }
}
